/* Skindae homepage — Figma 07102026 sections (sd-*). Tabs. */
(function () {
  if (window.__sdHome) return;
  window.__sdHome = true;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Tabs: roving tablist, one panel visible */
  if (!customElements.get('sd-tabs')) {
    customElements.define('sd-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach(function (tab, i) {
          tab.addEventListener('click', this.select.bind(this, i));
          tab.addEventListener('keydown', function (e) {
            var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
            if (!d) return;
            e.preventDefault();
            var n = (i + d + this.tabs.length) % this.tabs.length;
            this.select(n); this.tabs[n].focus();
          }.bind(this));
        }, this);
        this.bindAutoplay();
      }
      disconnectedCallback() { this.stopAuto(); if (this.io) this.io.disconnect(); }
      select(i) {
        this.tabs.forEach(function (tab, n) {
          var on = n === i;
          tab.setAttribute('aria-selected', on);
          tab.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        this.tabs[i].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
        this.startAuto(); /* new tab gets a full interval before its first move */
      }
      /* Auto-scroll (SD Tabbed products): one card every data-autoplay seconds while the section
         is on screen, only where the cards overflow (mobile). At the end: stop, or loop when
         data-autoplay-end="loop". A swipe/tap/focus on the cards stops it for good. */
      bindAutoplay() {
        this.secs = parseInt(this.dataset.autoplay, 10) || 0;
        if (!this.secs || reduceMotion || !('IntersectionObserver' in window)) return;
        var stopForGood = function () { this.userStopped = true; this.stopAuto(); }.bind(this);
        this.querySelectorAll('.sd-tab-panel').forEach(function (panel) {
          ['pointerdown', 'wheel', 'focusin'].forEach(function (type) { panel.addEventListener(type, stopForGood, { passive: true }); });
        });
        this.io = new IntersectionObserver(function (entries) {
          this.inView = entries[0].intersectionRatio >= 0.3;
          if (this.inView) this.startAuto(); else this.stopAuto();
        }.bind(this), { threshold: [0, 0.3] });
        this.io.observe(this);
      }
      startAuto() {
        this.stopAuto();
        if (!this.secs || this.userStopped || !this.inView) return;
        this.timer = setInterval(this.step.bind(this), this.secs * 1000);
      }
      stopAuto() { clearInterval(this.timer); }
      step() {
        var track = this.querySelector('.sd-tab-panel:not([hidden]) .sd-scroller');
        if (!track || track.children.length < 2) return;
        var max = track.scrollWidth - track.clientWidth;
        if (max < 2) return; /* everything fits (desktop grid) */
        if (track.scrollLeft >= max - 2) {
          if (this.dataset.autoplayEnd === 'loop') track.scrollTo({ left: 0, behavior: 'smooth' });
          else this.stopAuto();
          return;
        }
        var cards = track.children, base = cards[0].offsetLeft, left = max;
        for (var i = 1; i < cards.length; i++) {
          var x = cards[i].offsetLeft - base;
          if (x > track.scrollLeft + 2) { left = Math.min(x, max); break; }
        }
        track.scrollTo({ left: left, behavior: 'smooth' });
      }
    });
  }

  /* Desktop hero slider: scroll-snap track, segmented progress bar, autoplay,
     touch swipe (native) + mouse drag on the image. */
  if (!customElements.get('sd-slider')) {
    customElements.define('sd-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.sd-slider__track');
        this.segs = Array.from(this.querySelectorAll('.sd-slider__seg'));
        if (!this.track) return;
        this.count = this.track.children.length;
        this.index = 0;
        this.segs.forEach(function (seg, i) {
          seg.addEventListener('click', function () { this.stop(); this.go(i); }.bind(this));
        }, this);
        this.track.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
        this.bindDrag();
        var secs = parseInt(this.dataset.autoplay, 10) || 0;
        if (secs > 0 && this.count > 1 && !reduceMotion) {
          this.timer = setInterval(function () { this.go((this.index + 1) % this.count); }.bind(this), secs * 1000);
          this.addEventListener('focusin', this.stop.bind(this));
        }
      }
      disconnectedCallback() { this.stop(); }
      stop() { clearInterval(this.timer); }
      go(i) {
        this.track.scrollTo({ left: i * this.track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      onScroll() {
        var i = Math.round(this.track.scrollLeft / this.track.clientWidth);
        if (i === this.index) return;
        this.index = i;
        this.segs.forEach(function (seg, n) {
          if (n === i) seg.setAttribute('aria-current', 'true'); else seg.removeAttribute('aria-current');
        });
      }
      bindDrag() {
        var track = this.track, self = this, startX = 0, startLeft = 0, dragging = false, moved = false;
        track.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse' || e.button !== 0) return; /* touch uses native swipe */
          dragging = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
          self.stop(); track.classList.add('is-dragging');
        });
        window.addEventListener('pointermove', function (e) {
          if (!dragging) return;
          var dx = e.clientX - startX;
          if (Math.abs(dx) > 5) moved = true;
          track.scrollLeft = startLeft - dx;
        });
        window.addEventListener('pointerup', function (e) {
          if (!dragging) return;
          dragging = false; track.classList.remove('is-dragging');
          var dx = e.clientX - startX, w = track.clientWidth;
          var i = Math.round(startLeft / w) + (dx < -w * 0.15 ? 1 : dx > w * 0.15 ? -1 : 0);
          self.go(Math.max(0, Math.min(self.count - 1, i)));
        });
        /* a drag must not also follow the slide link */
        track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      }
    });
  }

  /* Ingredient slider: swipe (native scroll-snap) or the < > arrows beside each name; wraps around. */
  if (!customElements.get('sd-ingredients')) {
    customElements.define('sd-ingredients', class extends HTMLElement {
      connectedCallback() {
        var track = this.querySelector('.sd-ingr__track');
        if (!track) return;
        this.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-dir]');
          if (!btn) return;
          var n = track.children.length, w = track.clientWidth;
          var i = Math.round(track.scrollLeft / w) + parseInt(btn.dataset.dir, 10);
          i = (i + n) % n;
          track.scrollTo({ left: i * w, behavior: reduceMotion ? 'auto' : 'smooth' });
        });
      }
    });
  }

  /* Countdown: "[days] Days left" from an end date; hides itself once expired */
  if (!customElements.get('sd-countdown')) {
    customElements.define('sd-countdown', class extends HTMLElement {
      connectedCallback() {
        var end = new Date((this.dataset.end || '').replace(' ', 'T'));
        var out = this.querySelector('[data-days]');
        if (isNaN(end) || !out) return;
        var days = Math.ceil((end - Date.now()) / 86400000);
        if (days <= 0) { this.hidden = true; return; }
        out.textContent = (this.dataset.template || '[days] Days left').replace('[days]', days);
        this.hidden = false;
      }
    });
  }
})();
